import { render, staticRenderFns } from "./CountryTargetting.vue?vue&type=template&id=14f2961e&"
import script from "./CountryTargetting.vue?vue&type=script&lang=ts&"
export * from "./CountryTargetting.vue?vue&type=script&lang=ts&"
import style0 from "./CountryTargetting.vue?vue&type=style&index=0&id=14f2961e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports